<template>
  <v-card>
    <!-- 
      ********************
      Tabs
      ******************** 
    -->
    <v-tabs 
      v-model="selectedTab"
      color="pink"
      centered
      icons-and-text
      style="background-color: transparent !important"
    >
      <v-tabs-slider slider-color="pink"></v-tabs-slider>

      <v-tab style="background-color: transparent !important" href="#tab-edit">
        Edition des parcours
        <v-icon>mdi-pencil</v-icon>
      </v-tab>

      <v-tab style="background-color: transparent !important" href="#tab-order">
        Ordre des parcours par outil
        <v-icon>mdi-sort</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="selectedTab">
      <!-- 
        ********************
        Gestion des parcours
        ******************** 
      -->
      <v-tab-item class="pa-4" value="tab-edit">
        <v-card-title>
          Gestion des parcours
          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Rechercher sur les Noms, Thème, License type..."
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>

          <!-- bouton trash à partir de 2 checkbox de cocher -->
          <v-btn
            v-if="selected.length >= 2"
            class="mx-2"
            fab
            dark
            small
            color="red"
          >
            <v-icon
              dark
              v-model="selected"
              small
              @click="deleteCourses(selected[0].course)"
            >
              mdi-delete
            </v-icon>
          </v-btn>

          <router-link :to="{ name: 'creerParcours' }">
            <v-btn class="mx-2" fab dark small color="indigo">
              <v-icon dark> mdi-plus </v-icon>
            </v-btn>
          </router-link>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="courses"
          :search-input.sync="search"
          :items-per-page="12"
          :page.sync="pagination.currentPage"
          hide-default-footer
          v-model="selected"
          :single-select="singleSelect"
          show-select
        >
          <template v-slot:[`item.outils`]="{ item }">
            <span>{{ getRootThemeWithChildren(item.theme).title }}</span>
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            <span>{{ item.createdAt | moment }}</span>
          </template>
          <template v-slot:[`item.updatedAt`]="{ item }">
            <span>{{ item.updatedAt | moment }}</span>
          </template>
          <template v-slot:[`item.isVisible`]="{ item }">
            <span v-if="item.isVisible === true"
              ><p class="pt-4" style="color: blue">En ligne</p></span
            >
            <span v-else
              ><p class="pt-4" style="color: red">Hors ligne</p></span
            >
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <router-link
              :to="{
                name: 'modifierParcours',
                params: { id: item.id, course: item },
              }"
            >
              <v-icon small class="mr-2"> mdi-pencil </v-icon>
            </router-link>

            <v-icon small @click="deleteCourse(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table>

        <template>
          <v-pagination
            v-model="pagination.currentPage"
            :length="pagination.pagesNumber"
            @input="onPageChange"
            class="text-center py-5"
          ></v-pagination>
        </template>
      </v-tab-item>
      <!-- 
        ********************
        Ordre des parcours
        ******************** 
      -->
      <v-tab-item class="pa-4" value="tab-order">
        <div class="text-center" >
          
        </div>
        <div class="row ma-2 justify-items-center align-items-center">
          <v-banner
            class="col-sm-6"
            elevation="11"
            icon="mdi-information-outline"
            shaped
          >
            <ul class="ma-0">
              <li>Sélectionner un outil</li>
              <li>
                Modifier l'ordre des parcours en effectuer des glisser-déposer.
              </li>
              <li>
                Valider les changements en appuyant sur le bouton de validation.
              </li>
            </ul>
          </v-banner>
          <v-col class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
            <v-autocomplete
              v-model="selectedTheme"
              label="Sélection de l'outil"
              :items="parentThemes"
              item-key="id"
              item-text="title"
              return-object
              small-chips
              solo
              clearable
              hide-details
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  @click="data.select"
                >
                  <v-avatar left>
                    <v-img contain :src="getThemeLogo(data.item)"></v-img>
                  </v-avatar>
                  {{ data.item.title }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <template v-if="(typeof data.item !== 'object')">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-avatar>
                    <v-img contain :src="getThemeLogo(data.item)"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="data.item.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>
          </v-col>
        </div>
        <div class="row ma-2 justify-content-center">
          <div v-if="this.filters.theme" class="form-group col-12 pa-0 mt-10">
            <v-data-table
              :headers="tableHeaders"
              :items="selectedThemeCourses"
              :loading="loadingOrder"
              loading-text="Chargement des parcours.. veuillez patienter"
              item-key="id"
              dense
              :show-select="false"
              :disable-pagination="true"
              :hide-default-footer="true"
              class="page__table"
            >
              <template v-if="selectedThemeCourses.length > 0" v-slot:body>
                <draggable
                  tag="tbody"
                  v-model="selectedThemeCourses"
                  @start="dragging = true"
                  @end="onDragParentThemeEnd"
                >
                  <tr
                    v-for="(course, indexParent) in selectedThemeCourses"
                    :key="indexParent"
                  >
                    <td>
                      <v-icon small class="page__grab-icon">
                        mdi-arrow-all
                      </v-icon>
                    </td>
                    <td>{{ indexParent + 1 }}</td>
                    <td>
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                        "
                      >
                        <div>{{ course.title }}</div>
                      </div>
                    </td>
                  </tr>
                </draggable>
              </template>
              <template v-else v-slot:body>
                <tr><td :colspan="tableHeaders.length"><v-alert :value="true" color="error" icon="warning">
                  Aucune parcours disponible pour ce thème
                </v-alert></td></tr>
              </template>
            </v-data-table>
          </div>
        </div>
        <div class="mt-5 text-center">
          <!--<v-btn class="mr-15" style="background-color:#e6007e;color:white;"  @click="resetOrder">
            Réinitialisation de l'ordre des parcours
          </v-btn>-->
          <v-btn v-if="this.filters.theme" style="background-color:#e6007e;color:white;"  @click="updateCoursesOrder">
            Mise à jour de l'ordre
          </v-btn>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import moment from "moment";
import {
  userParentThemes,
  getRootThemeWithChildren,
} from "@/core/utils/userParentThemes";
//import ThemeSelect from "@/components/theme/themeSelect";
import draggable from "vuedraggable";
import { getThemeLogoUrl } from "@/core/utils/theme";
import { mapGetters } from "vuex";

export default {
  name: "courses",
  components: {
    //ThemeSelect,
    draggable,
  },
  data() {
    return {
      selectedTab: null,
      // Variables de gestion de l'ordre des parcours
      dragging: false,
      selectedTheme: null,
      selectedThemeCourses: [],
      themes: [],
      parentThemes: [],
      filters: {
        theme: localStorage[this.localStorageThemeKey] ?? null,
        toggleGroup: "allCourses",
      },
      tableHeaders: [
        { text: "", sortable: false },
        { text: "#", sortable: false },
        { text: "Parcours du thème", value: "title", sortable: false },
      ],
      loadingOrder: false,
      // Variables de gestion des parcours
      confirmDelete: false,
      loading: true,
      options: {},
      search: "",
      headers: [
        { text: "Nom", value: "title", align: "start" },
        { text: "Outil", value: "outils", align: "start" },
        { text: "Thème", value: "theme.title", align: "start" },
        { text: "Statut", value: "isVisible", align: "center" },
        { text: "Crée le", value: "createdAt", align: "center" },
        { text: "Modifié le", value: "updatedAt", align: "center" },
        { text: "Actions", value: "actions", sortable: false, align: "center" },
      ],
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
      deletedIndex: -1,
      singleSelect: false,
      selected: [], // Liste des parcours sélectionnés dans le tableau
      courses: [],
    };
  },
  props: {
    localStorageThemeKey: { type: String, default: "admin-course-theme" },
  },
  mounted() {
    if (localStorage.selectedTab) {
      this.selectedTab = localStorage.selectedTab;
    }
    Api.get("themes").then((themes) => {
      this.parentThemes = userParentThemes(themes.data["hydra:member"]);
      this.themes = themes.data["hydra:member"];
    });
    this.getAllCourses();
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
  },
  filters: {
    moment: function (date) {
      const d = moment(date);
      return d.isValid() ? d.format("DD/MM/YYYY") : "";
    },
  },
  watch: {
    selectedTheme(theme) {
      this.filters.theme = theme;
      if (this.filters.theme) {
        localStorage[this.localStorageThemeKey] = this.filters.theme.id;
        this.getAllThemeCourses(this.filters.theme.id);
      } else {
        this.selectedThemeCourses = [];
        localStorage.removeItem(this.localStorageThemeKey);
      }
    },
    selectedTab(value) {
      localStorage.selectedTab = value;
    },
    search(value) {
      this.pagination.currentPage = 1;
      this.getAllCourses(value);
    },
  },
  methods: {
    resetOrder(){
      Swal.fire({
        title: "Voulez-vous vraiment réinitialiser l'ordre de tous les parcours ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer le parcours et ses vidéos",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          Api.post("coursesinitializeorder").then( () => {
            Swal.fire(
              "Initialisation terminée !",
              "L'ordre des parcours a été réinitialisé",
              "success"
            );
            this.getAllCourses(this.search);
          }).catch(()=>
            Swal.fire(
                "Initialisation en échec !",
                "L'ordre des parcours n'a pas pu être réinitialisé",
                "error"
          ));
        }
      });    
    },
    updateCoursesOrder(){
      if(this.selectedTheme && this.selectedThemeCourses){
        let position = 0;
        let promises = [];
        this.selectedThemeCourses.forEach(course => {
          promises.push(Api.patch("courses", course.id, {"position": position }));
          position++;
        });

        Promise.all(promises).then(() => {
          Swal.fire(
            "Mise à jour !",
            "L'ordre des parcours a été modifié",
            "success"
          );
          this.getAllCourses(this.search);
        });

      }
    },
    getThemeLogo(theme) {
      return getThemeLogoUrl(
        theme,
        process.env.BASE_URL + this.layoutConfig("self.nologo")
      );
    },
    onDragParentThemeEnd() {
      this.dragging = false;
      return true;
    },
    getAllThemeCourses(searchedTheme) {
      this.loadingOrder = true;
      Api.query("courses", { params: { theme: searchedTheme }}).then(
        (courses) => {
          this.selectedThemeCourses = courses.data["hydra:member"];
          this.loadingOrder = false;
        }
      );
    },
    getAllCourses(search = "") {
      this.loading = true;
      Api.query("courses?page=" + this.pagination.currentPage, {
        params: { title: search },
      }).then((courses) => {
        this.courses = courses.data["hydra:member"];
        this.pagination.pagesNumber = Math.ceil(
          courses.data["hydra:totalItems"] / 12 //12 car côté API le nombre de parcours est réglé a 12 par page
        );
        this.loading = false;
      });
    },
    onPageChange() {
      //Pagination
      this.getAllCourses();
    },
    deleteCourse(item) {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer ce parcours ?",
        text: "Attention, cette action est irréversible ! Vous allez également supprimer toutes les vidéos qui se trouvent dans ce parcours !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer le parcours et ses vidéos",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletedIndex = this.courses.indexOf(item);
          Api.delete("courses/" + item.id).then(() => {
            this.courses.splice(this.deletedIndex, 1),
              Swal.fire(
                "Supprimé !",
                "Votre parcours a été supprimé",
                "success"
              ),
              this.getAllCourses();
          });
        }
      });
    },
    deleteCourses() {
      Swal.fire({
        title: "Voulez-vous vraiment supprimer ces parcours ?",
        text: "Attention, cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
      }).then((result) => {
        if (result.isConfirmed) {
          const selectedItems = this.selected;
          for (var i = 0; i < selectedItems.length; i++) {
            Api.delete("courses/" + selectedItems[i].id).then(() => {
              //TODO : appeler la fonction de callback. cf https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Promise/all
              Swal.fire(
                "Supprimé !",
                "Vos parcours ont été supprimés",
                "success"
              ),
                this.getAllCourses();
              this.selected = [];
            });
          }
        }
      });
    },
    getRootThemeWithChildren: (theme) => getRootThemeWithChildren(theme),
  },
};
</script>

